export class CondicionPago {

  static ESTATUS_ACTIVO = "A";
  static ESTATUS_ACTIVO_LABEL = "Activo";
  static ESTATUS_INACTIVO = "I";
  static ESTATUS_INACTIVO_LABEL = "Inactivo";

  static get ESTATUS_LIST() {
    return [
      {
        value: CondicionPago.ESTATUS_ACTIVO,
        label: CondicionPago.ESTATUS_ACTIVO_LABEL,
      },
      {
        value: CondicionPago.ESTATUS_INACTIVO,
        label: CondicionPago.ESTATUS_INACTIVO_LABEL,
      },
    ];
  }

  static get PROPIEDADES_EXPORTAR () {
    return [
      {
        value: "IdSec",
        label: "Id"
      },
      {
        value: "Descripcion",
        label: "Descripción"
      },
      {
        value: "Dias",
        label: "Días"
      },
      {
        value: "EstatusDesc",
        label: "Estatus"
      },
      {
        value: "FechaCreacion",
        label: "Fecha Creación"
      },
      {
        value: "CrearUsuario",
        label: "Usuario Creación"
      },
      {
        value: "FechaActualizacion",
        label: "Fecha Actualización"
      },
      {
        value: "ActualizarUsuario",
        label: "Usuario Actualización"
      }
    ]
  }
}
